<span class="carousel-form__title fs__md fw__500">Options</span>
<empathy-choices-form [question]="question()" [disabled]="disabled()"></empathy-choices-form>
<span class="carousel-form__title fs__md fw__500">Ranks</span>
<empathy-choices-form [question]="question()" [disabled]="disabled()" [isRankSort]="true"></empathy-choices-form>
